import type { Endpoint, Request, RequestArgs, Route } from '../types.no-deps'
import type { GetAllWithNamesOptions, TSimpleUnit } from '../../../shared/domain/units/types.no-deps'

export const route: Route = { method: 'GET', pattern: '/api/unitsWithNames' }

type Params = never
type Body = never
type Query = Omit<GetAllWithNamesOptions, 'unitIds'>
type Output = { units: Array<TSimpleUnit & { id: number; lastMod: Date }> }

export type GetAllWithNamesEndpoint = Endpoint<Params, Body, Query, Output>

export const getAllWithNamesRequest = (request: Request, args: RequestArgs<GetAllWithNamesEndpoint>) =>
    request<GetAllWithNamesEndpoint>(route, args)
